import $ from "jquery";

export default {
    init() {
        let options = {
            'host': "https://www.instagram.com/",
            'username': 'nexfit',
            'tag': '',
            'items': 10,
        };
        initInstFeed(options);

        function initInstFeed(options) {
            $('.section__inst').show();
            let is_tag = options.username === "",
                url = is_tag ? options.host + "explore/tags/"+ options.tag : options.host + options.username;

            $.get(url, function(data) {
                data = data.split("window._sharedData = ")[1].split("<\/script>")[0];
                data = JSON.parse(data.substr(0, data.length - 1));
                data = data.entry_data.ProfilePage || data.entry_data.TagPage;
                data = data[0].graphql.user || data[0].graphql.hashtag;
                //console.log(data);

                let imgs = (data.edge_owner_to_timeline_media || data.edge_hashtag_to_media).edges;
                let max = (imgs.length > options.items) ? options.items : imgs.length;

                for(let i = 0; i < max; i++){
                    let url = "https://www.instagram.com/p/" + imgs[i].node.shortcode;
                    let image = imgs[i].node.thumbnail_src;

                    $('.publications').append(
                        $('<a href="' + url + '" class="publication" target="_blank"><img class="publication__img" src="' + image + '">'),
                    );
                }

                $('.account__followers--count').text(roundToK(data.edge_followed_by.count));
                $('.account__publications--count').text(roundToK(data.edge_owner_to_timeline_media.count));
                $('.account__logo').attr('src' , data.profile_pic_url);
                $('.account__name').text(data.username);
                $('.account__personal-link').attr('href' , 'https://www.instagram.com/' + data.username);
                $('.inst__loader').hide();
            }).fail(function(e){

            });
        }

        function roundToK(number)
        {
            if (number > 999) {
                return Math.round(number / 1000) + 'K';
            }
            return number;
        }
    },

    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};
